import { render, staticRenderFns } from "./ChangeUserPassword.vue?vue&type=template&id=b4eeeb30&"
import script from "./ChangeUserPassword.vue?vue&type=script&lang=js&"
export * from "./ChangeUserPassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangeUserPassword.vue?vue&type=style&index=0&id=b4eeeb30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports